/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import React, {useEffect, useRef, useState} from "react";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {ManageSearch} from "@mui/icons-material";
import Tarjeta_Valor_Titulo_Grafica from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Valor_Titulo_Grafica";
import Dona_Limpia from "../../Modulo_Graficas/Graficas/Dona_Limpia";
import Area_Limpia from "../../Modulo_Graficas/Graficas/Area_Limpia";
import {arrConteoColMesesAtras} from "../../Servicios/BD/Contadores_Arr/arrConteoColMesesAtras";
import {arrConteoColSemanasAtras} from "../../Servicios/BD/Contadores_Arr/arrConteoColSemanasAtras";
import {arrConteoColPropiedadEstados} from "../../Servicios/BD/Contadores_Arr/arrConteoColPropiedadEstados";
import {ESTADOSPQRS} from "../../Constantes";
import Dialogo_Pqrs from "../Dialogos/Dialogo_Pqrs";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";


const Seccion_Pqrs = () => {
    const refe = useRef()
    const {alto} = useObtenerAlto({contenedor: refe})
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente,
    } = useObtenerColleccionTabla2025({coleccion: 'pqrs'})
    const [potencialesMeses, setPotencialesMeses] = useState([])
    const [potencialesSemanas, setPotencialesSemanas] = useState([])
    const [potencialesEstado, setPotencialesEstado] = useState([])
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Pqrs,
        titulo: 'Detalles de Pqrs',
        realizado: cargarNuevamente
    })
    const altoGraficas = 160


    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)

        }
    }

    useEffect(() => {

        arrConteoColMesesAtras({coleccion: 'pqrs', mesesAtras: 6}).then((arr) => {
            setPotencialesMeses(arr)
        })

        arrConteoColSemanasAtras({coleccion: 'pqrs', semanasAtras: 4}).then((arr) => {
            setPotencialesSemanas(arr)
        })

        arrConteoColPropiedadEstados({
            coleccion: 'pqrs',
            propiedad: 'estado',
            arrEstados: ESTADOSPQRS.map((it) => it.nombre)
        }).then((arr) => {
            setPotencialesEstado(arr)
        })


    }, []);
    return (
        <Grid2 container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid2 ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Pqrs'}
                        subtitulo={'Ultimos 6 meses'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: new Date().getFullYear(),
                                    data: potencialesMeses.map((it) => it.cantidad)

                                }
                            ]
                        }
                        labels={potencialesMeses.map((it) => it.nombre)}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Valor_Titulo_Grafica valor={'Estados'}
                                                  titulo={'3 Tipos '}
                                                  height={altoGraficas}
                                                  Grafica={Dona_Limpia}
                                                  marginTop={-5}
                                                  px={1}
                                                  series={potencialesEstado.map((it) => it.cantidad)}
                                                  labels={potencialesEstado.map((it) => it.nombre)}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Valor_Titulo_Grafica valor={'Ultimo'}
                                                  titulo={'Mes'}
                                                  marginTop={0}
                                                  Grafica={Area_Limpia}
                                                  height={altoGraficas}
                                                  marginTop={-5}
                                                  series={
                                                      [
                                                          {
                                                              name: new Date().getFullYear() - 2,
                                                              data: potencialesSemanas.map((it) => it.cantidad)
                                                          }
                                                      ]
                                                  }
                                                  labels={potencialesSemanas.map((it) => it.nombre)}/>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Pqrs'}
                        descripcion={'Base de datos de pqrs'}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid2>


            </Grid2>

        </Grid2>
    )

}


export default Seccion_Pqrs

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'Tipo',
        direccion: 'right',
        propiedad: 'opcion',
        tipo: CASILLA_TEXTO,

    },
    {
        nombre: 'Correo',
        direccion: 'right',
        propiedad: 'correo',
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPQRS
    }


]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]
